import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "click-box",
  class: "tw-relative tw-w-[421px] tw-px-[12px]"
}
const _hoisted_2 = { class: "tw-text-[#211F58] tw-text-[22px] tw-font-semibold tw-text-center tw-leading-[100%] tw-pb-[20px]" }
const _hoisted_3 = { class: "tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[150%] tw-text-center" }
const _hoisted_4 = { class: "tw-text-center" }

import { getComponentUiText } from "@/utils/utilities";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'noDataRecommendations',
  setup(__props) {

const rejectAssessment = () => {
  router.push({
    path: "/assess/manage",
    query: {
      param: "OpenModalAssessment",
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-landing-recommendations-page-title-1")), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-assess-recommendations-no-data-content-1")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_b_button, {
        variant: "primary",
        class: "button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
        onClick: rejectAssessment
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-assess-recommendations-no-data-button-1")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})